import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../App.css"; // Tailwind and other styles
import { AppDispatch } from "../app/store";
import ChatWindow from "../component/ChatWindow";
import Sidebar from "../component/Sidebar";
import { setTheme } from "../features/themeSlice";
import ModalDeleteChat from "../modals/ModalDeleteChat";
import { RootState, SidebarState } from "../types";
import { getCookieToken, setCookieToken } from "../utils";

const Chat: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const overlayRef = useRef<HTMLDivElement | null>(null);
  // Type the selector hook properly
  const theme = useSelector((state: RootState) => state.theme.theme);
  const modals = useSelector((state: RootState) => state.modal.modals);
  const modalProps = useSelector((state: RootState) => state.modal.props);
  const isMinimized = useSelector((state: { theme: SidebarState }) => state.theme.minimize);
  useEffect(() => {
    const savedTheme = getCookieToken("theme");
    if (savedTheme && (savedTheme === "light" || savedTheme === "dark")) {
      dispatch(setTheme(savedTheme));
    } else {
      dispatch(setTheme("light")); // Default to light theme
    }
  }, [dispatch]);

  useEffect(() => {
    document.documentElement.className = theme;
    setCookieToken("theme", theme);
  }, []);

  return (
    <div className={`flex h-[100dvh] w-full sm:pb-[20px] pb-2`} ref={overlayRef}>
      {modals.ModalDeleteChat && (
        <ModalDeleteChat id={modalProps.id ?? 0} type={modalProps.type ?? "chat"} />
      )}{" "}
      <Sidebar />
      <div className={`flex-1 w-full md:px-0 sm:pt-5 pt-2 px-2 ${isMinimized ? "lg:relative md:z-[60]" : ""}`}>
        <ChatWindow  />
      </div>
    </div>
  );
};

export default Chat;
